import VConsole from 'vconsole'

// 仅在开发环境实例化vconsole
if (location.href.indexOf('localhost') > -1 || location.href.indexOf('192.168') > -1 || location.href.indexOf('wwwpre') > -1) {
    const vConsole = new VConsole({
        maxLogNumber: 1000,
        theme: 'light'
    })

    // 可选：将vconsole实例暴露到window，方便在控制台操作
    //window.vConsole = vConsole

    console.log('vConsole已在开发环境启用')
}
